import { ApiRequestOptions } from '@api/types/utils/api-request-options';
import { BACKEND_URL } from '../../../constants';

export type BuildUrlOptions<I = string, S = string> = ApiRequestOptions & {
  sort?: S;
  page?: number;
  include?: I[];
  groupBy?: string;
  append?: string;
  randomSeed?: string;
};

export type BuildUrlSearch = Record<string, string | number | undefined | null>;

export const buildUrl = <F extends object, I = string>(
  path: string,
  options: BuildUrlOptions<I> = {},
  filters?: F,
  search: BuildUrlSearch = {}
): string => {
  const endpoint = `${BACKEND_URL}${path}`;
  return buildUrlPath(endpoint, options, filters, search);
};

export const buildUrlPath = <F extends object, I = string>(
  path: string,
  options: BuildUrlOptions<I> = {},
  filters?: F,
  search: BuildUrlSearch = {}
): string => {
  const endpoint = `${path}`;
  const urlParams = new URLSearchParams();

  if (options.sort) {
    urlParams.set('sort', options.sort);
  }
  if (options.perPage) {
    urlParams.set('per_page', options.perPage.toString());
  }
  if (options.page) {
    urlParams.set('page', options.page.toString());
  }
  if (options.groupBy) {
    urlParams.set('group_by', options.groupBy);
  }
  if (options.append) {
    urlParams.set('append', options.append);
  }
  if (options.randomSeed) {
    urlParams.set('random_seed', options.randomSeed);
  }
  if (options.include) {
    urlParams.set('include', options.include.join(','));
  }

  if (filters) {
    addObject(urlParams, filters, 'filter');
  }

  if (search) {
    addObject(urlParams, search);
  }

  return `${endpoint}?${urlParams.toString()}`;
};

const addObject = (urlParams: URLSearchParams, object: object, namespace?: string) => {
  Object.entries(object).forEach(([name, value]) => {
    if (!value) {
      return;
    }
    const key = namespace ? `${namespace}[${name}]` : name;
    urlParams.set(key, typeof value === 'number' ? value.toString() : value);
  });
};
